<section class="relative md:py-24 py-16">
  <div class="container">
      <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
          <div class="lg:col-span-4 md:col-span-6">
              <div class="sticky top-20">

                  <img [src]="infobox?.afbeelding" alt="" />

                  <div class="text-center mt-8">
                    <p class="text-lg font-medium h5">{{infobox?.titel}}</p>
                    <p class="text-md font-thin h5">{{infobox?.subtitel}}</p>
                  </div>

                  <a class="hover:text-white transition-all duration-500 ease-in-out" [href]="infobox?.link" target="_blank"><h5 *ngIf="infobox?.link" class="text-lg font-medium bg-earth-try/40 hover:bg-earth-dark shadow rounded-md p-2 text-center mt-8"><i class="uil uil-globe mr-2" *ngIf="infobox?.link"></i> Link</h5></a>
              </div>
          </div>

          <div class="lg:col-span-8 md:col-span-6">
            <div class="relative overflow-hidden rounded-md shadow dark:shadow-gray-800">
                <div class="p-6">
                    <h2 class="text-2xl">{{infobox?.titel}}</h2>
                    <h3 class="text-xl text-slate-300">{{infobox?.subtitel}}</h3>
                    <p class="text-slate-400 mt-4" [innerHTML]="infobox?.omschrijving | mdtohtml"></p>
                </div>
            </div>
        </div>
      </div>
  </div>

  <div class="container mt-8" *ngIf="infoboxes.length > 0">
      <div class="grid grid-cols-1 text-center">
          <h3 class="mb-4 md:text-[26px] md:leading-normal text-2xl leading-normal font-semibold">Ook iets voor jou?</h3>

          <!--<p class="text-slate-400 dark:text-slate-300 max-w-xl mx-auto">Bekijk de andere vormingen die we organiseren.</p>-->
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-[30px] mt-2">

          <app-infobox-card *ngFor="let box of infoboxes" [infobox]="box"></app-infobox-card>
          <!--end content-->
      </div><!--end grid-->
  </div><!--end container-->

</section>
